import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import ActionService from "services/ActionService";

let initialState = { list: [], actionRoles: [], roleSelected: [], directorlist: [], userActions: [] };

export const getRoleList = createAsyncThunk(
  "configAction/getRole",
  async () => {
    const response = await ActionService.getRoleList();
    if (response?.results?.length > 0) {
      response.results.forEach(a => {
        a.selected = 'N'
      });
    }
    return response?.results;
  }
);


export const getConfigActionListDirector = createAsyncThunk(
  "configAction/getConfigActionListDirector",
  async (body = null) => {



    const response = await ActionService.getConfigActionDirectorList(body);


    return response?.results;
  }
);

export const getConfigActionList = createAsyncThunk(
  "configAction/getConfigAction",
  async () => {



    const response = await ActionService.getConfigActionList();


    return response?.results;
  }
);

export const getActionRoles = createAsyncThunk(
  "configAction/getActionRoles",
  async () => {
    const response = await ActionService.getActionRoles();
    if (response?.results?.length > 0) {
      response.results.forEach(a => {
        a.laststatus = a.status
      });
    }
    return response?.results;
  }
);


export const getActionUser = createAsyncThunk(
  "configAction/getActionUser",
  async (userId, { getState }) => {
    const response = await ActionService.getActionUser(userId);
    if (response?.results?.length > 0) {
      response.results.forEach(a => {
        a.laststatus = a.status;
      });
    }
    return response?.results;
  }
);





export const addMenu = createAsyncThunk(
  "configAction/addMenu",
  async (body) => {
    const response = await ActionService.addMenu(body);
    return response?.results;
  }
);


export const addSubMenu = createAsyncThunk(
  "configAction/addSubMenu",
  async (body) => {
    const response = await ActionService.addSubMenu(body);
    return response?.results;
  }
);

export const addAction = createAsyncThunk(
  "configAction/addAction",
  async (body) => {
    const response = await ActionService.addAction(body);
    return response?.results;
  }
);



export const configActionRoes = createAsyncThunk(
  "configAction/configActionRoes",
  async (body) => {
    const response = await ActionService.configActionRoes(body);
    return response?.results;
  }
);

export const getUserActionsForDirector = createAsyncThunk(
  "configAction/getUserActionsForDirector",
  async () => {
    const response = await ActionService.getUserActionsForDirector();
    return response?.results;
  }
);

export const addUserActions = createAsyncThunk(
  "configAction/addUserActions",
  async (body) => {
    const response = await ActionService.addUserActions(body);
    return response?.status;
  }
);






const configActionSlice = createSlice({
  name: "configAction",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
    setActiveAction: (state, action) => {
      const actionNo = action.payload;
      const actionRoles = state.actionRoles.filter(a => actionNo === a.actionNo);

      state.roleSelected.forEach(r => {
        const role = actionRoles.find(a => a.role === r.roleId && a.status === 'Y');
        if (role) {
          r.selected = 'Y'
        }
        else {
          r.selected = 'N'
        }
      });
    },
    changeActionStatus: (state, action) => {
      const { role, selected, actionData } = action.payload;
      const status = (selected) ? 'Y' : 'N';

      // set role actvie/inactive
      const _role = state.roleSelected.find(x => x.roleId === role.roleId);
      if (_role) { _role.selected = status; }

      // set action roles for edit and add new item
      const actionRole = state.actionRoles.find(x => x.actionNo === actionData.actionNo && x.role === role.roleId);
      if (actionRole) {
        actionRole.status = status;
      }
      else {
        state.actionRoles.push({
          actionNo: actionData.actionNo,
          menuNo: actionData.menuNo,
          role: role.roleId,
          status: status,
          subMenuNo: actionData.subMenuNo,
          isNew: true
        })
      }
    }
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getConfigActionList, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(getConfigActionListDirector, builder, ["directorlist"]);
    LoadingAdapter.applyAsyncBuilder(getActionRoles, builder, ["actionRoles"]);
    LoadingAdapter.applyAsyncBuilder(getRoleList, builder, ["roleSelected"]);
    LoadingAdapter.applyAsyncBuilder(getActionUser, builder, ["actions"]);
    LoadingAdapter.applyAsyncBuilder(getUserActionsForDirector, builder, ["userActions"]);
    LoadingAdapter.applyAsyncBuilder(addMenu, builder);
    LoadingAdapter.applyAsyncBuilder(addSubMenu, builder);
    LoadingAdapter.applyAsyncBuilder(addAction, builder);
    LoadingAdapter.applyAsyncBuilder(addUserActions, builder);
  },
});


export const { setActiveAction, changeActionStatus } = configActionSlice.actions
export default configActionSlice.reducer;
